module.exports = TalendAssetsApi;